export default {
  seo: {
    title: 'Cài đặt SEO',
    types: {
      defaultGlobe: 'Mặc định toàn cục',
      home: 'Trang chủ',
      // compat old keys
      promotionList: 'Danh sách khuyến mãi',
      promotionDetail: 'Chi tiết khuyến mãi',
      pointsMall: 'Cửa hàng điểm',
      aiRecommend: 'Gợi ý AI',
      helpCenter: 'Trung tâm trợ giúp',
      helpArticleDetail: 'Chi tiết bài viết trợ giúp',
      // new backend typeKey
      'promo-list': 'Danh sách khuyến mãi',
      'promo-detail': 'Chi tiết khuyến mãi',
      points: 'Cửa hàng điểm',
      'ai-picks': 'Gợi ý AI',
      'help-index': 'Trung tâm trợ giúp',
      'help-article': 'Chi tiết bài viết trợ giúp',
      vip: 'Trang VIP',
      'vip-rules': 'Quy tắc VIP'
    },
    form: {
      searchLabel: 'Tìm kiếm',
      searchPlaceholder: 'Tìm theo tên / từ khóa',
      query: 'Tìm',
      reset: 'Đặt lại',
      add: 'Thêm trang',
      languageLabel: 'Ngôn ngữ',
      languagePh: 'Chọn ngôn ngữ',
      typeLabel: 'Loại trang',
      typeAll: 'Tất cả',
      statusLabel: 'Trạng thái',
      statusAll: 'Tất cả',
      statusEnabled: 'Bật',
      statusDisabled: 'Tắt'
    },
    table: {
      name: 'Tên trang',
      isGlobalTag: 'Toàn cục',
      dynamicParams: 'Tham số động',
      yes: 'Có',
      no: 'Không',
      coreSeo: 'SEO cốt lõi',
      socialOg: 'OG mạng xã hội',
      enabled: 'Bật',
      action: 'Thao tác',
      edit: 'Sửa',
      preview: 'Xem trước',
      delete: 'Xóa',
      total: 'Tổng {{count}} mục',
      updatedByText: 'Cập nhật: {{updatedAt}} · Bởi: {{updatedBy}}',
      keywordPrefix: 'Từ khóa: {{text}}',
      ogImageHas: 'Có ảnh',
      ogImageNone: 'Không ảnh',
      ogTitleShort: 'OGT: {{text}}',
      ogDescShort: 'OGD: {{text}}',
      ogKeywordShort: 'OGK: {{text}}',
      ogImageConfigured: 'Đã cấu hình',
      ogImageNotConfigured: 'Chưa cấu hình'
    },
    modal: {
      createTitle: 'Tạo trang',
      editTitle: 'Sửa trang',
      previewTitle: 'Xem trước',
      fields: {
        type: 'Loại trang',
        typePh: 'Chọn loại trang',
        name: 'Tên trang',
        namePh: 'Định danh duy nhất, vd: home, promotion-detail',
        enabled: 'Bật',
        isGlobal: 'Toàn cục',
        hasOG: 'Có thông tin OG',
        hasDynamicParams: 'Có tham số động',
        paramNames: 'Tên tham số',
        paramNamesPh: 'vd: id, slug (phân tách bằng dấu phẩy)',
        title: 'Tiêu đề',
        titlePh: 'Hỗ trợ {{pageTitle}}',
        meta: 'Mô tả',
        metaPh: 'Tóm tắt trang',
        canonical: 'Liên kết canonical',
        canonicalPh: 'Liên kết canonical',
        keyword: 'Từ khóa',
        keywordPh: 'Phân tách bằng dấu phẩy',
        ogTitle: 'Tiêu đề OG',
        ogDesc: 'Mô tả OG',
        ogKeyword: 'Từ khóa OG',
        ogImage: 'Ảnh OG',
        ogImagePh: 'https://...'
      },
      ok: 'Xác nhận',
      cancel: 'Hủy',
      deleteConfirmTitle: 'Xác nhận xóa',
      deleteConfirmContent: 'Xóa trang "{{name}}"?'
    },
    message: {
      queryFailed: 'Truy vấn thất bại',
      createSuccess: 'Tạo thành công',
      createFailed: 'Tạo thất bại',
      updateSuccess: 'Cập nhật thành công',
      updateFailed: 'Cập nhật thất bại',
      opFailed: 'Thao tác thất bại',
      enabled: 'Đã bật',
      disabled: 'Đã tắt',
      deleteSuccess: 'Xóa thành công',
      deleteFailed: 'Xóa thất bại'
    }
  }
};


